import React from "react";
import styled from "styled-components";
import { DeleteOutlined } from "@ant-design/icons";
import { media } from "../styles";
import { Tabel } from "../core";

const CHANGE_DATE_FORMAT = require("../helper/utils/datFormat");

const StyledTabel = styled(Tabel)`
  .ant-table-thead > tr > th {
    background: none;
    font-weight: 500;
    font-size: 18px;
    line-height: 27px;
    border-bottom: 2px solid #e7ecf4;

    color: #404e67;
  }
  .ant-table-tbody > tr > td {
    font-size: 16px;
    line-height: 20px;
    color: #404e67;
    border-bottom: 2px solid #e7ecf4;
  }
  .ant-table-tbody > tr:last-child td {
    border-bottom: none;
  }
  .ant-table-container {
    ${media.minidesktop`overflow-x: scroll;`};
  }
`;
const DeleteButton = styled.button`
  background: #f56a9e;
  box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.15);
  border-radius: 8px;
  width: 37.82px;
  height: 37px;
  color: white;
  border: none;
  cursor: pointer;
`;
const paymentDataSource = [
  {
    key: "1",
    date: "23-3-2020",
    amount: "567",
    paymentMethod: "Drafts",
    action: "Bill Added",
  },
  {
    key: "1",
    date: "23-3-2020",
    amount: "567",
    paymentMethod: "Drafts",
    action: "Bill Added",
  },
  {
    key: "1",
    date: "23-3-2020",
    amount: "567",
    paymentMethod: "Drafts",
    action: "Bill Added",
  },
];

const paymentsColumns = [
  {
    title: "Date",
    dataIndex: "date",
    key: "date",
    width: 150,
    render: (text, record, index) => {
      return (
        <span>
          {/* {record.invoice_date}
          <br /> */}
          {CHANGE_DATE_FORMAT.changeDateFormat(record.date)}
        </span>
      );
    },
  },
  {
    title: "Amount",
    dataIndex: "amount",
    key: "amount",
    width: 150,
  },
  {
    title: "Payment Method",
    dataIndex: "paymentMethod",
    key: "paymentMethod",
    width: 150,
  },
  {
    title: "Action",
    dataIndex: "action",
    key: "action",
    render: () => (
      <DeleteButton>
        <DeleteOutlined />
      </DeleteButton>
    ),
    width: 150,
  },
];
const AddPaymentHistory = () => {
  return (
    <StyledTabel
      dataSource={paymentDataSource}
      pagination={false}
      columns={paymentsColumns}
    />
  );
};

export default AddPaymentHistory;
